import { render, staticRenderFns } from "./TypeStockManual.vue?vue&type=template&id=1c4e15ec&"
import script from "./TypeStockManual.vue?vue&type=script&lang=js&"
export * from "./TypeStockManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports